/* tslint:disable */
/* eslint-disable */
/**
 * EVA Digital Experience API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var AccessibilityFeatureEnum;
(function (AccessibilityFeatureEnum) {
    AccessibilityFeatureEnum["AccessibleApproachWithRamp"] = "Accessible Approach with Ramp";
    AccessibilityFeatureEnum["AccessibleBedroom"] = "Accessible Bedroom";
    AccessibilityFeatureEnum["AccessibleCentralLivingArea"] = "Accessible Central Living Area";
    AccessibilityFeatureEnum["AccessibleClosets"] = "Accessible Closets";
    AccessibilityFeatureEnum["AccessibleCommonArea"] = "Accessible Common Area";
    AccessibilityFeatureEnum["AccessibleDoors"] = "Accessible Doors";
    AccessibilityFeatureEnum["AccessibleElectricalAndEnvironmentalControls"] = "Accessible Electrical and Environmental Controls";
    AccessibilityFeatureEnum["AccessibleElevatorInstalled"] = "Accessible Elevator Installed";
    AccessibilityFeatureEnum["AccessibleEntrance"] = "Accessible Entrance";
    AccessibilityFeatureEnum["AccessibleForHearingImpairment"] = "Accessible for Hearing Impairment";
    AccessibilityFeatureEnum["AccessibleFullBath"] = "Accessible Full Bath";
    AccessibilityFeatureEnum["AccessibleHallwayS"] = "Accessible Hallway(s)";
    AccessibilityFeatureEnum["AccessibleKitchen"] = "Accessible Kitchen";
    AccessibilityFeatureEnum["AccessibleKitchenAppliances"] = "Accessible Kitchen Appliances";
    AccessibilityFeatureEnum["AccessibleStairway"] = "Accessible Stairway";
    AccessibilityFeatureEnum["AccessibleWasherDryer"] = "Accessible Washer/Dryer";
    AccessibilityFeatureEnum["AdaptableBathroomWalls"] = "Adaptable Bathroom Walls";
    AccessibilityFeatureEnum["AdaptableForElevator"] = "Adaptable For Elevator";
    AccessibilityFeatureEnum["CeilingTrack"] = "Ceiling Track";
    AccessibilityFeatureEnum["CentralLivingArea"] = "Central Living Area";
    AccessibilityFeatureEnum["CommonArea"] = "Common Area";
    AccessibilityFeatureEnum["CustomizedWheelchairAccessible"] = "Customized Wheelchair Accessible";
    AccessibilityFeatureEnum["ElectronicEnvironmentalControls"] = "Electronic Environmental Controls";
    AccessibilityFeatureEnum["EnhancedAccessible"] = "Enhanced Accessible";
    AccessibilityFeatureEnum["ExteriorWheelchairLift"] = "Exterior WheelchairLift";
    AccessibilityFeatureEnum["GripAccessibleFeatures"] = "Grip-Accessible Features";
    AccessibilityFeatureEnum["ReinforcedFloors"] = "Reinforced Floors";
    AccessibilityFeatureEnum["SafeEmergencyEgressFromHome"] = "Safe Emergency Egress from Home";
    AccessibilityFeatureEnum["SmartTechnology"] = "Smart Technology";
    AccessibilityFeatureEnum["StairLift"] = "Stair Lift";
    AccessibilityFeatureEnum["StandbyGenerator"] = "Standby Generator";
    AccessibilityFeatureEnum["TherapeuticWhirlpool"] = "Therapeutic Whirlpool";
    AccessibilityFeatureEnum["Visitable"] = "Visitable";
    AccessibilityFeatureEnum["VisitorBathroom"] = "Visitor Bathroom";
    AccessibilityFeatureEnum["WalkerAccessibleStairs"] = "Walker-Accessible Stairs";
})(AccessibilityFeatureEnum || (AccessibilityFeatureEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ApplianceEnum;
(function (ApplianceEnum) {
    ApplianceEnum["BarFridge"] = "Bar Fridge";
    ApplianceEnum["BuiltInElectricOven"] = "Built-In Electric Oven";
    ApplianceEnum["BuiltInElectricRange"] = "Built-In Electric Range";
    ApplianceEnum["BuiltInFreezer"] = "Built-In Freezer";
    ApplianceEnum["BuiltInGasOven"] = "Built-In Gas Oven";
    ApplianceEnum["BuiltInGasRange"] = "Built-In Gas Range";
    ApplianceEnum["BuiltInRange"] = "Built-In Range";
    ApplianceEnum["BuiltInRefrigerator"] = "Built-In Refrigerator";
    ApplianceEnum["ConvectionOven"] = "Convection Oven";
    ApplianceEnum["Cooktop"] = "Cooktop";
    ApplianceEnum["Dishwasher"] = "Dishwasher";
    ApplianceEnum["Disposal"] = "Disposal";
    ApplianceEnum["DoubleOven"] = "Double Oven";
    ApplianceEnum["DownDraft"] = "Down Draft";
    ApplianceEnum["Dryer"] = "Dryer";
    ApplianceEnum["ElectricCooktop"] = "Electric Cooktop";
    ApplianceEnum["ElectricOven"] = "Electric Oven";
    ApplianceEnum["ElectricRange"] = "Electric Range";
    ApplianceEnum["ElectricWaterHeater"] = "Electric Water Heater";
    ApplianceEnum["EnergyStarQualifiedAppliances"] = "ENERGY STAR Qualified Appliances";
    ApplianceEnum["EnergyStarQualifiedDishwasher"] = "ENERGY STAR Qualified Dishwasher";
    ApplianceEnum["EnergyStarQualifiedDryer"] = "ENERGY STAR Qualified Dryer";
    ApplianceEnum["EnergyStarQualifiedFreezer"] = "ENERGY STAR Qualified Freezer";
    ApplianceEnum["EnergyStarQualifiedRefrigerator"] = "ENERGY STAR Qualified Refrigerator";
    ApplianceEnum["EnergyStarQualifiedWasher"] = "ENERGY STAR Qualified Washer";
    ApplianceEnum["EnergyStarQualifiedWaterHeater"] = "ENERGY STAR Qualified Water Heater";
    ApplianceEnum["ExhaustFan"] = "Exhaust Fan";
    ApplianceEnum["FreeStandingElectricOven"] = "Free-Standing Electric Oven";
    ApplianceEnum["FreeStandingElectricRange"] = "Free-Standing Electric Range";
    ApplianceEnum["FreeStandingFreezer"] = "Free-Standing Freezer";
    ApplianceEnum["FreeStandingGasOven"] = "Free-Standing Gas Oven";
    ApplianceEnum["FreeStandingGasRange"] = "Free-Standing Gas Range";
    ApplianceEnum["FreeStandingRange"] = "Free-Standing Range";
    ApplianceEnum["FreeStandingRefrigerator"] = "Free-Standing Refrigerator";
    ApplianceEnum["Freezer"] = "Freezer";
    ApplianceEnum["GasCooktop"] = "Gas Cooktop";
    ApplianceEnum["GasOven"] = "Gas Oven";
    ApplianceEnum["GasRange"] = "Gas Range";
    ApplianceEnum["GasWaterHeater"] = "Gas Water Heater";
    ApplianceEnum["Humidifier"] = "Humidifier";
    ApplianceEnum["IceMaker"] = "Ice Maker";
    ApplianceEnum["IndoorGrill"] = "Indoor Grill";
    ApplianceEnum["InductionCooktop"] = "Induction Cooktop";
    ApplianceEnum["InstantHotWater"] = "Instant Hot Water";
    ApplianceEnum["Microwave"] = "Microwave";
    ApplianceEnum["None"] = "None";
    ApplianceEnum["Other"] = "Other";
    ApplianceEnum["Oven"] = "Oven";
    ApplianceEnum["PlumbedForIceMaker"] = "Plumbed For IceMaker";
    ApplianceEnum["PortableDishwasher"] = "Portable Dishwasher";
    ApplianceEnum["PropaneCooktop"] = "Propane Cooktop";
    ApplianceEnum["Range"] = "Range";
    ApplianceEnum["RangeHood"] = "Range Hood";
    ApplianceEnum["Refrigerator"] = "Refrigerator";
    ApplianceEnum["SelfCleaningOven"] = "Self Cleaning Oven";
    ApplianceEnum["SolarHotWater"] = "Solar Hot Water";
    ApplianceEnum["StainlessSteelApplianceS"] = "Stainless Steel Appliance(s)";
    ApplianceEnum["TanklessWaterHeater"] = "Tankless Water Heater";
    ApplianceEnum["TrashCompactor"] = "Trash Compactor";
    ApplianceEnum["VentedExhaustFan"] = "Vented Exhaust Fan";
    ApplianceEnum["WarmingDrawer"] = "Warming Drawer";
    ApplianceEnum["Washer"] = "Washer";
    ApplianceEnum["WasherDryer"] = "Washer/Dryer";
    ApplianceEnum["WasherDryerStacked"] = "Washer/Dryer Stacked";
    ApplianceEnum["WaterHeater"] = "Water Heater";
    ApplianceEnum["WaterPurifier"] = "Water Purifier";
    ApplianceEnum["WaterPurifierOwned"] = "Water Purifier Owned";
    ApplianceEnum["WaterPurifierRented"] = "Water Purifier Rented";
    ApplianceEnum["WaterSoftener"] = "Water Softener";
    ApplianceEnum["WaterSoftenerOwned"] = "Water Softener Owned";
    ApplianceEnum["WaterSoftenerRented"] = "Water Softener Rented";
    ApplianceEnum["WineCooler"] = "Wine Cooler";
    ApplianceEnum["WineRefrigerator"] = "Wine Refrigerator";
})(ApplianceEnum || (ApplianceEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ClosePriceToDisplayEnum;
(function (ClosePriceToDisplayEnum) {
    ClosePriceToDisplayEnum["ClosePrice"] = "ClosePrice";
    ClosePriceToDisplayEnum["ListPrice"] = "ListPrice";
})(ClosePriceToDisplayEnum || (ClosePriceToDisplayEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var CategoriesEnum;
(function (CategoriesEnum) {
    CategoriesEnum["Alcohol"] = "alcohol";
    CategoriesEnum["Airports"] = "airports";
    CategoriesEnum["ArtCultureScience"] = "art_culture_science";
    CategoriesEnum["BusStops"] = "bus_stops";
    CategoriesEnum["Cafes"] = "cafes";
    CategoriesEnum["CarFuelingStations"] = "car_fueling_stations";
    CategoriesEnum["ClothingShops"] = "clothing_shops";
    CategoriesEnum["CommonNeeds"] = "common_needs";
    CategoriesEnum["ConferenceCenters"] = "conference_centers";
    CategoriesEnum["Daycares"] = "daycares";
    CategoriesEnum["Entertainment"] = "entertainment";
    CategoriesEnum["Fitness"] = "fitness";
    CategoriesEnum["Groceries"] = "groceries";
    CategoriesEnum["GroceriesSpecialized"] = "groceries_specialized";
    CategoriesEnum["HealthCare"] = "health_care";
    CategoriesEnum["HomeImprovement"] = "home_improvement";
    CategoriesEnum["Hospitals"] = "hospitals";
    CategoriesEnum["Libraries"] = "libraries";
    CategoriesEnum["Nightlife"] = "nightlife";
    CategoriesEnum["Parks"] = "parks";
    CategoriesEnum["PersonalCare"] = "personal_care";
    CategoriesEnum["PetCare"] = "pet_care";
    CategoriesEnum["Pharmacies"] = "pharmacies";
    CategoriesEnum["RapidTransitStations"] = "rapid_transit_stations";
    CategoriesEnum["Restaurants"] = "restaurants";
    CategoriesEnum["Retail"] = "retail";
    CategoriesEnum["ShopsAndServices"] = "shops_and_services";
    CategoriesEnum["SportFacilities"] = "sport_facilities";
    CategoriesEnum["TrainStations"] = "train_stations";
})(CategoriesEnum || (CategoriesEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LeaseAmountFrequencyEnum;
(function (LeaseAmountFrequencyEnum) {
    LeaseAmountFrequencyEnum["Annually"] = "Annually";
    LeaseAmountFrequencyEnum["BiMonthly"] = "Bi-Monthly";
    LeaseAmountFrequencyEnum["BiWeekly"] = "Bi-Weekly";
    LeaseAmountFrequencyEnum["Daily"] = "Daily";
    LeaseAmountFrequencyEnum["Monthly"] = "Monthly";
    LeaseAmountFrequencyEnum["OneTime"] = "One Time";
    LeaseAmountFrequencyEnum["Quarterly"] = "Quarterly";
    LeaseAmountFrequencyEnum["Seasonal"] = "Seasonal";
    LeaseAmountFrequencyEnum["SemiAnnually"] = "Semi-Annually";
    LeaseAmountFrequencyEnum["SemiMonthly"] = "Semi-Monthly";
    LeaseAmountFrequencyEnum["Weekly"] = "Weekly ";
})(LeaseAmountFrequencyEnum || (LeaseAmountFrequencyEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LifestyleVerticalEnum;
(function (LifestyleVerticalEnum) {
    LifestyleVerticalEnum["WaterOcean"] = "Water|Ocean";
    LifestyleVerticalEnum["WaterLake"] = "Water|Lake";
    LifestyleVerticalEnum["WaterRiver"] = "Water|River";
    LifestyleVerticalEnum["WaterView"] = "Water|View";
    LifestyleVerticalEnum["WaterAccess"] = "Water|Access";
    LifestyleVerticalEnum["WaterWaterfront"] = "Water|Waterfront";
    LifestyleVerticalEnum["WaterDock"] = "Water|Dock";
    LifestyleVerticalEnum["WaterMooring"] = "Water|Mooring";
    LifestyleVerticalEnum["GolfOnCourse"] = "Golf|On Course";
    LifestyleVerticalEnum["GolfCommunity"] = "Golf|Community";
    LifestyleVerticalEnum["GolfLot"] = "Golf|Lot";
    LifestyleVerticalEnum["MountainMountain"] = "Mountain|Mountain";
    LifestyleVerticalEnum["MountainWater"] = "Mountain|Water";
    LifestyleVerticalEnum["MountainCity"] = "Mountain|City";
    LifestyleVerticalEnum["WineVineyardWine"] = "Wine/Vineyard|Wine";
    LifestyleVerticalEnum["WineVineyardVineyard"] = "Wine/Vineyard|Vineyard";
    LifestyleVerticalEnum["RanchRecreationalRanchFishing"] = "Ranch|Recreational Ranch|Fishing";
    LifestyleVerticalEnum["RanchRecreationalRanchHunting"] = "Ranch|Recreational Ranch|Hunting";
    LifestyleVerticalEnum["RanchRecreationalRanchSportsTrails"] = "Ranch|Recreational Ranch|Sports/Trails";
    LifestyleVerticalEnum["RanchRecreationalRanchRanchEstate"] = "Ranch|Recreational Ranch|Ranch Estate";
    LifestyleVerticalEnum["RanchRecreationalRanchOpenLand"] = "Ranch|Recreational Ranch|Open Land";
    LifestyleVerticalEnum["RanchRecreationalRanchHospitalityDudeRanch"] = "Ranch|Recreational Ranch|Hospitality/Dude Ranch";
    LifestyleVerticalEnum["RanchWorkingRanchEquestrian"] = "Ranch|Working Ranch|Equestrian";
    LifestyleVerticalEnum["RanchWorkingRanchLivestock"] = "Ranch|Working Ranch|Livestock";
    LifestyleVerticalEnum["RanchWorkingRanchAgriculture"] = "Ranch|Working Ranch|Agriculture";
    LifestyleVerticalEnum["Equestrian"] = "Equestrian";
    LifestyleVerticalEnum["SkiSkiInSkiOut"] = "Ski|Ski In/Ski Out";
})(LifestyleVerticalEnum || (LifestyleVerticalEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ListingSortKeys;
(function (ListingSortKeys) {
    ListingSortKeys["UsdListPrice"] = "UsdListPrice";
    ListingSortKeys["EvaId"] = "EvaId";
    ListingSortKeys["OnMarketDate"] = "OnMarketDate";
    ListingSortKeys["ListAgentMlsId"] = "ListAgentMlsId";
})(ListingSortKeys || (ListingSortKeys = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LivingAreaUnitsEnum;
(function (LivingAreaUnitsEnum) {
    LivingAreaUnitsEnum["SquareFeet"] = "Square Feet";
    LivingAreaUnitsEnum["SquareMeters"] = "Square Meters";
})(LivingAreaUnitsEnum || (LivingAreaUnitsEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LocalLogicCountry;
(function (LocalLogicCountry) {
    LocalLogicCountry["Usa"] = "USA";
    LocalLogicCountry["Canada"] = "Canada";
})(LocalLogicCountry || (LocalLogicCountry = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LocalLogicLocale;
(function (LocalLogicLocale) {
    LocalLogicLocale["En"] = "en";
    LocalLogicLocale["Fr"] = "fr";
})(LocalLogicLocale || (LocalLogicLocale = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LocalLogicPoiType;
(function (LocalLogicPoiType) {
    LocalLogicPoiType["Alcohol"] = "alcohol";
    LocalLogicPoiType["Airports"] = "airports";
    LocalLogicPoiType["ArtCultureScience"] = "art_culture_science";
    LocalLogicPoiType["BusStops"] = "bus_stops";
    LocalLogicPoiType["Cafes"] = "cafes";
    LocalLogicPoiType["CarFuelingStations"] = "car_fueling_stations";
    LocalLogicPoiType["ClothingShops"] = "clothing_shops";
    LocalLogicPoiType["CommonNeeds"] = "common_needs";
    LocalLogicPoiType["ConferenceCenters"] = "conference_centers";
    LocalLogicPoiType["Daycares"] = "daycares";
    LocalLogicPoiType["Entertainment"] = "entertainment";
    LocalLogicPoiType["Fitness"] = "fitness";
    LocalLogicPoiType["Groceries"] = "groceries";
    LocalLogicPoiType["GroceriesSpecialized"] = "groceries_specialized";
    LocalLogicPoiType["HealthCare"] = "health_care";
    LocalLogicPoiType["HomeImprovement"] = "home_improvement";
    LocalLogicPoiType["Hospitals"] = "hospitals";
    LocalLogicPoiType["Libraries"] = "libraries";
    LocalLogicPoiType["Nightlife"] = "nightlife";
    LocalLogicPoiType["Parks"] = "parks";
    LocalLogicPoiType["PersonalCare"] = "personal_care";
    LocalLogicPoiType["PetCare"] = "pet_care";
    LocalLogicPoiType["Pharmacies"] = "pharmacies";
    LocalLogicPoiType["RapidTransitStations"] = "rapid_transit_stations";
    LocalLogicPoiType["Restaurants"] = "restaurants";
    LocalLogicPoiType["Retail"] = "retail";
    LocalLogicPoiType["ShopsAndServices"] = "shops_and_services";
    LocalLogicPoiType["SportFacilities"] = "sport_facilities";
    LocalLogicPoiType["TrainStations"] = "train_stations";
})(LocalLogicPoiType || (LocalLogicPoiType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LocalLogicRadiusUnit;
(function (LocalLogicRadiusUnit) {
    LocalLogicRadiusUnit["Mile"] = "mile";
    LocalLogicRadiusUnit["Meter"] = "meter";
})(LocalLogicRadiusUnit || (LocalLogicRadiusUnit = {}));
/**
    * @export
    * @enum {string}
    */
export var OpenHouseTypeEnum;
(function (OpenHouseTypeEnum) {
    OpenHouseTypeEnum["Broker"] = "broker";
    OpenHouseTypeEnum["LivestreamBroker"] = "livestream broker";
    OpenHouseTypeEnum["Office"] = "office";
    OpenHouseTypeEnum["Public"] = "public";
})(OpenHouseTypeEnum || (OpenHouseTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ParkingFeatureEnum;
(function (ParkingFeatureEnum) {
    ParkingFeatureEnum["AdditionalParking"] = "Additional Parking";
    ParkingFeatureEnum["Aggregate"] = "Aggregate";
    ParkingFeatureEnum["AlleyAccess"] = "Alley Access";
    ParkingFeatureEnum["Asphalt"] = "Asphalt";
    ParkingFeatureEnum["Assigned"] = "Assigned";
    ParkingFeatureEnum["Attached"] = "Attached";
    ParkingFeatureEnum["AttachedCarport"] = "Attached Carport";
    ParkingFeatureEnum["Basement"] = "Basement";
    ParkingFeatureEnum["Boat"] = "Boat";
    ParkingFeatureEnum["Carport"] = "Carport";
    ParkingFeatureEnum["CircularDriveway"] = "Circular Driveway";
    ParkingFeatureEnum["Common"] = "Common";
    ParkingFeatureEnum["CommunityStructure"] = "Community Structure";
    ParkingFeatureEnum["Concrete"] = "Concrete";
    ParkingFeatureEnum["ConvertedGarage"] = "Converted Garage";
    ParkingFeatureEnum["Covered"] = "Covered";
    ParkingFeatureEnum["Deck"] = "Deck";
    ParkingFeatureEnum["Deeded"] = "Deeded";
    ParkingFeatureEnum["Detached"] = "Detached";
    ParkingFeatureEnum["DetachedCarport"] = "Detached Carport";
    ParkingFeatureEnum["DirectAccess"] = "Direct Access";
    ParkingFeatureEnum["DriveThrough"] = "Drive Through";
    ParkingFeatureEnum["Driveway"] = "Driveway";
    ParkingFeatureEnum["ElectricGate"] = "ElectricGate";
    ParkingFeatureEnum["ElectricVehicleChargingStationS"] = "Electric Vehicle Charging Station(s)";
    ParkingFeatureEnum["Enclosed"] = "Enclosed";
    ParkingFeatureEnum["Garage"] = "Garage";
    ParkingFeatureEnum["GarageDoorOpener"] = "Garage Door Opener";
    ParkingFeatureEnum["GarageFacesFront"] = "Garage Faces Front";
    ParkingFeatureEnum["GarageFacesRear"] = "Garage Faces Rear";
    ParkingFeatureEnum["GarageFacesSide"] = "Garage Faces Side";
    ParkingFeatureEnum["Gated"] = "Gated";
    ParkingFeatureEnum["GolfCartGarage"] = "Golf Cart Garage";
    ParkingFeatureEnum["Gravel"] = "Gravel";
    ParkingFeatureEnum["Guest"] = "Guest";
    ParkingFeatureEnum["HeatedGarage"] = "Heated Garage";
    ParkingFeatureEnum["InsideEntrance"] = "Inside Entrance";
    ParkingFeatureEnum["KitchenLevel"] = "Kitchen Level";
    ParkingFeatureEnum["Leased"] = "Leased";
    ParkingFeatureEnum["Lighted"] = "Lighted";
    ParkingFeatureEnum["NoGarage"] = "No Garage";
    ParkingFeatureEnum["None"] = "None";
    ParkingFeatureEnum["OffSite"] = "Off Site";
    ParkingFeatureEnum["OffStreet"] = "Off Street";
    ParkingFeatureEnum["OnSite"] = "On Site";
    ParkingFeatureEnum["OnStreet"] = "On Street";
    ParkingFeatureEnum["Open"] = "Open";
    ParkingFeatureEnum["Other"] = "Other";
    ParkingFeatureEnum["Outside"] = "Outside";
    ParkingFeatureEnum["Oversized"] = "Oversized";
    ParkingFeatureEnum["ParkingLot"] = "Parking Lot";
    ParkingFeatureEnum["ParkingPad"] = "Parking Pad";
    ParkingFeatureEnum["Paved"] = "Paved";
    ParkingFeatureEnum["PaverBlock"] = "Paver Block";
    ParkingFeatureEnum["PermitRequired"] = "Permit Required";
    ParkingFeatureEnum["Private"] = "Private";
    ParkingFeatureEnum["RvAccessParking"] = "RV Access/Parking";
    ParkingFeatureEnum["RvCarport"] = "RV Carport";
    ParkingFeatureEnum["RvGarage"] = "RV Garage";
    ParkingFeatureEnum["RvGated"] = "RV Gated";
    ParkingFeatureEnum["Secured"] = "Secured";
    ParkingFeatureEnum["SeeRemarks"] = "See Remarks";
    ParkingFeatureEnum["SharedDriveway"] = "Shared Driveway";
    ParkingFeatureEnum["SideBySide"] = "Side By Side";
    ParkingFeatureEnum["Storage"] = "Storage";
    ParkingFeatureEnum["Tandem"] = "Tandem";
    ParkingFeatureEnum["Unassigned"] = "Unassigned";
    ParkingFeatureEnum["Underground"] = "Underground";
    ParkingFeatureEnum["Unpaved"] = "Unpaved";
    ParkingFeatureEnum["Valet"] = "Valet";
    ParkingFeatureEnum["VariesByUnit"] = "Varies by Unit";
    ParkingFeatureEnum["WorkshopInGarage"] = "Workshop in Garage";
})(ParkingFeatureEnum || (ParkingFeatureEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PetsAllowedEnum;
(function (PetsAllowedEnum) {
    PetsAllowedEnum["BreedRestrictions"] = "Breed Restrictions";
    PetsAllowedEnum["Call"] = "Call";
    PetsAllowedEnum["CatsOk"] = "Cats OK";
    PetsAllowedEnum["DogsOk"] = "Dogs OK";
    PetsAllowedEnum["No"] = "No";
    PetsAllowedEnum["NumberLimit"] = "Number Limit";
    PetsAllowedEnum["SizeLimit"] = "Size Limit";
    PetsAllowedEnum["Yes"] = "Yes";
})(PetsAllowedEnum || (PetsAllowedEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PredictionTypeEnum;
(function (PredictionTypeEnum) {
    PredictionTypeEnum["Country"] = "country";
    PredictionTypeEnum["State"] = "state";
    PredictionTypeEnum["City"] = "city";
    PredictionTypeEnum["CityRegion"] = "city_region";
    PredictionTypeEnum["PostalCode"] = "postal_code";
    PredictionTypeEnum["Neighborhood"] = "neighborhood";
    PredictionTypeEnum["Address"] = "address";
})(PredictionTypeEnum || (PredictionTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PropertySubTypeEnum;
(function (PropertySubTypeEnum) {
    PropertySubTypeEnum["Agriculture"] = "Agriculture";
    PropertySubTypeEnum["Apartment"] = "Apartment";
    PropertySubTypeEnum["BoatSlip"] = "BoatSlip";
    PropertySubTypeEnum["Business"] = "Business";
    PropertySubTypeEnum["Cabin"] = "Cabin";
    PropertySubTypeEnum["Condominium"] = "Condominium";
    PropertySubTypeEnum["DeededParking"] = "Deeded Parking";
    PropertySubTypeEnum["Duplex"] = "Duplex";
    PropertySubTypeEnum["Farm"] = "Farm";
    PropertySubTypeEnum["HotelMotel"] = "Hotel/Motel";
    PropertySubTypeEnum["Industrial"] = "Industrial";
    PropertySubTypeEnum["ManufacturedHome"] = "Manufactured Home";
    PropertySubTypeEnum["ManufacturedOnLand"] = "Manufactured On Land";
    PropertySubTypeEnum["MixedUse"] = "Mixed Use";
    PropertySubTypeEnum["MobileHome"] = "Mobile Home";
    PropertySubTypeEnum["MultiFamily"] = "Multi Family";
    PropertySubTypeEnum["Office"] = "Office";
    PropertySubTypeEnum["OwnYourOwn"] = "Own Your Own";
    PropertySubTypeEnum["Quadruplex"] = "Quadruplex";
    PropertySubTypeEnum["Ranch"] = "Ranch";
    PropertySubTypeEnum["Retail"] = "Retail";
    PropertySubTypeEnum["SingleFamilyResidence"] = "Single Family Residence";
    PropertySubTypeEnum["StockCooperative"] = "Stock Cooperative";
    PropertySubTypeEnum["Timeshare"] = "Timeshare";
    PropertySubTypeEnum["Townhouse"] = "Townhouse";
    PropertySubTypeEnum["Triplex"] = "Triplex";
    PropertySubTypeEnum["UnimprovedLand"] = "Unimproved Land";
    PropertySubTypeEnum["Warehouse"] = "Warehouse";
})(PropertySubTypeEnum || (PropertySubTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    PropertyTypeEnum["BusinessOpportunity"] = "Business Opportunity";
    PropertyTypeEnum["CommercialLease"] = "Commercial Lease";
    PropertyTypeEnum["CommercialSale"] = "Commercial Sale";
    PropertyTypeEnum["Farm"] = "Farm";
    PropertyTypeEnum["Land"] = "Land";
    PropertyTypeEnum["ManufacturedInPark"] = "Manufactured In Park";
    PropertyTypeEnum["Residential"] = "Residential";
    PropertyTypeEnum["ResidentialIncome"] = "Residential Income";
    PropertyTypeEnum["ResidentialLease"] = "Residential Lease";
})(PropertyTypeEnum || (PropertyTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SortDir;
(function (SortDir) {
    SortDir["Asc"] = "asc";
    SortDir["Desc"] = "desc";
})(SortDir || (SortDir = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var StandardStatusEnum;
(function (StandardStatusEnum) {
    StandardStatusEnum["Active"] = "Active";
    StandardStatusEnum["ActiveUnderContract"] = "Active Under Contract";
    StandardStatusEnum["Canceled"] = "Canceled";
    StandardStatusEnum["Closed"] = "Closed";
    StandardStatusEnum["ComingSoon"] = "Coming Soon";
    StandardStatusEnum["Delete"] = "Delete";
    StandardStatusEnum["Expired"] = "Expired";
    StandardStatusEnum["Hold"] = "Hold";
    StandardStatusEnum["Incomplete"] = "Incomplete";
    StandardStatusEnum["Pending"] = "Pending";
    StandardStatusEnum["Withdrawn"] = "Withdrawn";
    StandardStatusEnum["OffMarket"] = "Off Market";
})(StandardStatusEnum || (StandardStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var StateOrProvinceEnum;
(function (StateOrProvinceEnum) {
    StateOrProvinceEnum["Ab"] = "AB";
    StateOrProvinceEnum["Ak"] = "AK";
    StateOrProvinceEnum["Al"] = "AL";
    StateOrProvinceEnum["Ar"] = "AR";
    StateOrProvinceEnum["Az"] = "AZ";
    StateOrProvinceEnum["Bc"] = "BC";
    StateOrProvinceEnum["Ca"] = "CA";
    StateOrProvinceEnum["Co"] = "CO";
    StateOrProvinceEnum["Ct"] = "CT";
    StateOrProvinceEnum["Dc"] = "DC";
    StateOrProvinceEnum["De"] = "DE";
    StateOrProvinceEnum["Fl"] = "FL";
    StateOrProvinceEnum["Ga"] = "GA";
    StateOrProvinceEnum["Hi"] = "HI";
    StateOrProvinceEnum["Ia"] = "IA";
    StateOrProvinceEnum["Id"] = "ID";
    StateOrProvinceEnum["Il"] = "IL";
    StateOrProvinceEnum["In"] = "IN";
    StateOrProvinceEnum["Ks"] = "KS";
    StateOrProvinceEnum["Ky"] = "KY";
    StateOrProvinceEnum["La"] = "LA";
    StateOrProvinceEnum["Ma"] = "MA";
    StateOrProvinceEnum["Mb"] = "MB";
    StateOrProvinceEnum["Md"] = "MD";
    StateOrProvinceEnum["Me"] = "ME";
    StateOrProvinceEnum["Mi"] = "MI";
    StateOrProvinceEnum["Mn"] = "MN";
    StateOrProvinceEnum["Mo"] = "MO";
    StateOrProvinceEnum["Ms"] = "MS";
    StateOrProvinceEnum["Mt"] = "MT";
    StateOrProvinceEnum["Nb"] = "NB";
    StateOrProvinceEnum["Nc"] = "NC";
    StateOrProvinceEnum["Nd"] = "ND";
    StateOrProvinceEnum["Ne"] = "NE";
    StateOrProvinceEnum["Nf"] = "NF";
    StateOrProvinceEnum["Nh"] = "NH";
    StateOrProvinceEnum["Nj"] = "NJ";
    StateOrProvinceEnum["Nm"] = "NM";
    StateOrProvinceEnum["Ns"] = "NS";
    StateOrProvinceEnum["Nt"] = "NT";
    StateOrProvinceEnum["Nu"] = "NU";
    StateOrProvinceEnum["Nv"] = "NV";
    StateOrProvinceEnum["Ny"] = "NY";
    StateOrProvinceEnum["Oh"] = "OH";
    StateOrProvinceEnum["Ok"] = "OK";
    StateOrProvinceEnum["On"] = "ON";
    StateOrProvinceEnum["Or"] = "OR";
    StateOrProvinceEnum["Pa"] = "PA";
    StateOrProvinceEnum["Pe"] = "PE";
    StateOrProvinceEnum["Qc"] = "QC";
    StateOrProvinceEnum["Ri"] = "RI";
    StateOrProvinceEnum["Sc"] = "SC";
    StateOrProvinceEnum["Sd"] = "SD";
    StateOrProvinceEnum["Sk"] = "SK";
    StateOrProvinceEnum["Tn"] = "TN";
    StateOrProvinceEnum["Tx"] = "TX";
    StateOrProvinceEnum["Ut"] = "UT";
    StateOrProvinceEnum["Va"] = "VA";
    StateOrProvinceEnum["Vi"] = "VI";
    StateOrProvinceEnum["Vt"] = "VT";
    StateOrProvinceEnum["Wa"] = "WA";
    StateOrProvinceEnum["Wi"] = "WI";
    StateOrProvinceEnum["Wv"] = "WV";
    StateOrProvinceEnum["Wy"] = "WY";
    StateOrProvinceEnum["Yt"] = "YT";
})(StateOrProvinceEnum || (StateOrProvinceEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ViewEnum;
(function (ViewEnum) {
    ViewEnum["Bay"] = "Bay";
    ViewEnum["Beach"] = "Beach";
    ViewEnum["BridgeS"] = "Bridge(s)";
    ViewEnum["Canal"] = "Canal";
    ViewEnum["Canyon"] = "Canyon";
    ViewEnum["City"] = "City";
    ViewEnum["CityLights"] = "City Lights";
    ViewEnum["CreekStream"] = "Creek/Stream";
    ViewEnum["Desert"] = "Desert";
    ViewEnum["Downtown"] = "Downtown";
    ViewEnum["Forest"] = "Forest";
    ViewEnum["Garden"] = "Garden";
    ViewEnum["GolfCourse"] = "Golf Course";
    ViewEnum["Hills"] = "Hills";
    ViewEnum["Lake"] = "Lake";
    ViewEnum["Marina"] = "Marina";
    ViewEnum["Meadow"] = "Meadow";
    ViewEnum["Mountains"] = "Mountains";
    ViewEnum["Neighborhood"] = "Neighborhood";
    ViewEnum["None"] = "None";
    ViewEnum["Ocean"] = "Ocean";
    ViewEnum["Orchard"] = "Orchard";
    ViewEnum["Other"] = "Other";
    ViewEnum["Panoramic"] = "Panoramic";
    ViewEnum["ParkGreenbelt"] = "Park/Greenbelt";
    ViewEnum["Pasture"] = "Pasture";
    ViewEnum["Pond"] = "Pond";
    ViewEnum["Pool"] = "Pool";
    ViewEnum["Ridge"] = "Ridge";
    ViewEnum["River"] = "River";
    ViewEnum["Rural"] = "Rural";
    ViewEnum["SeeRemarks"] = "See Remarks";
    ViewEnum["Skyline"] = "Skyline";
    ViewEnum["Territorial"] = "Territorial";
    ViewEnum["TreesWoods"] = "Trees/Woods";
    ViewEnum["Valley"] = "Valley";
    ViewEnum["Vineyard"] = "Vineyard";
    ViewEnum["Water"] = "Water";
})(ViewEnum || (ViewEnum = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Manually trigger aggregation of searched areas
         * @param {GetFrequentlySearchedAreaDto} getFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggreateSearchedAreas: (getFrequentlySearchedAreaDto_1, ...args_1) => __awaiter(this, [getFrequentlySearchedAreaDto_1, ...args_1], void 0, function* (getFrequentlySearchedAreaDto, options = {}) {
            // verify required parameter 'getFrequentlySearchedAreaDto' is not null or undefined
            assertParamExists('aggreateSearchedAreas', 'getFrequentlySearchedAreaDto', getFrequentlySearchedAreaDto);
            const localVarPath = `/frequently-searched-areas/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getFrequentlySearchedAreaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create lofty leads with notes
         * @param {CreateLoftyLeadDto} createLoftyLeadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoftyLeads: (createLoftyLeadDto_1, ...args_1) => __awaiter(this, [createLoftyLeadDto_1, ...args_1], void 0, function* (createLoftyLeadDto, options = {}) {
            // verify required parameter 'createLoftyLeadDto' is not null or undefined
            assertParamExists('createLoftyLeads', 'createLoftyLeadDto', createLoftyLeadDto);
            const localVarPath = `/lofty/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createLoftyLeadDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes a listing from user favorites
         * @param {string} userId
         * @param {string} favoriteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite: (userId_1, favoriteId_1, ...args_1) => __awaiter(this, [userId_1, favoriteId_1, ...args_1], void 0, function* (userId, favoriteId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteFavorite', 'userId', userId);
            // verify required parameter 'favoriteId' is not null or undefined
            assertParamExists('deleteFavorite', 'favoriteId', favoriteId);
            const localVarPath = `/users/{userId}/favorites/{favoriteId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"favoriteId"}}`, encodeURIComponent(String(favoriteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes a search from user saved searches
         * @param {string} userId
         * @param {string} searchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedSearch: (userId_1, searchId_1, ...args_1) => __awaiter(this, [userId_1, searchId_1, ...args_1], void 0, function* (userId, searchId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteSavedSearch', 'userId', userId);
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('deleteSavedSearch', 'searchId', searchId);
            const localVarPath = `/users/{userId}/saved-searches/{searchId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"searchId"}}`, encodeURIComponent(String(searchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves all advisors
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetAdvisorsSortKeyEnum} [sortKey]
         * @param {GetAdvisorsSortDirEnum} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisors: (page_1, size_1, sortKey_1, sortDir_1, ...args_1) => __awaiter(this, [page_1, size_1, sortKey_1, sortDir_1, ...args_1], void 0, function* (page, size, sortKey, sortDir, options = {}) {
            const localVarPath = `/advisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves advisors for a specific shop(s)
         * @param {string} shopIds
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetAdvisorsByShopSortKeyEnum} [sortKey]
         * @param {GetAdvisorsByShopSortDirEnum} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisorsByShop: (shopIds_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1) => __awaiter(this, [shopIds_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1], void 0, function* (shopIds, page, size, sortKey, sortDir, options = {}) {
            // verify required parameter 'shopIds' is not null or undefined
            assertParamExists('getAdvisorsByShop', 'shopIds', shopIds);
            const localVarPath = `/shops/{shopIds}/advisors`
                .replace(`{${"shopIds"}}`, encodeURIComponent(String(shopIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves contentful neighborhoods with matching search term & country
         * @param {string} searchTerm
         * @param {string} locale
         * @param {Array<string>} [countries]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentfulNeighborhoodsBySearchTerm: (searchTerm_1, locale_1, countries_1, ...args_1) => __awaiter(this, [searchTerm_1, locale_1, countries_1, ...args_1], void 0, function* (searchTerm, locale, countries, options = {}) {
            // verify required parameter 'searchTerm' is not null or undefined
            assertParamExists('getContentfulNeighborhoodsBySearchTerm', 'searchTerm', searchTerm);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getContentfulNeighborhoodsBySearchTerm', 'locale', locale);
            const localVarPath = `/neighborhoods/contentful`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary return data dictionary of currencies and their rates
         * @param {string} [baseCurrency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyConversions: (baseCurrency_1, ...args_1) => __awaiter(this, [baseCurrency_1, ...args_1], void 0, function* (baseCurrency, options = {}) {
            const localVarPath = `/currency-conversions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (baseCurrency !== undefined) {
                localVarQueryParameter['baseCurrency'] = baseCurrency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all favorites for a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites: (userId_1, ...args_1) => __awaiter(this, [userId_1, ...args_1], void 0, function* (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getFavorites', 'userId', userId);
            const localVarPath = `/users/{userId}/favorites`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets most recent frequently searched areas
         * @param {GetFrequentlySearchedAreaDto} getFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequentlySearchedAreas: (getFrequentlySearchedAreaDto_1, ...args_1) => __awaiter(this, [getFrequentlySearchedAreaDto_1, ...args_1], void 0, function* (getFrequentlySearchedAreaDto, options = {}) {
            // verify required parameter 'getFrequentlySearchedAreaDto' is not null or undefined
            assertParamExists('getFrequentlySearchedAreas', 'getFrequentlySearchedAreaDto', getFrequentlySearchedAreaDto);
            const localVarPath = `/frequently-searched-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getFrequentlySearchedAreaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a list by EvaId or ListingId
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListingById', 'id', id);
            const localVarPath = `/listings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves detailed information for a listing by EvaId or ListingId
         * @summary
         * @param {string} id
         * @param {string} mls
         * @param {string} [status]
         * @param {string} [select]
         * @param {string} [expand]
         * @param {string} [locale]
         * @param {boolean} [locationData]
         * @param {boolean} [isDevelopment]
         * @param {boolean} [reconvert]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingDetailsById: (id_1, mls_1, status_1, select_1, expand_1, locale_1, locationData_1, isDevelopment_1, reconvert_1, ...args_1) => __awaiter(this, [id_1, mls_1, status_1, select_1, expand_1, locale_1, locationData_1, isDevelopment_1, reconvert_1, ...args_1], void 0, function* (id, mls, status, select, expand, locale, locationData, isDevelopment, reconvert, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListingDetailsById', 'id', id);
            // verify required parameter 'mls' is not null or undefined
            assertParamExists('getListingDetailsById', 'mls', mls);
            const localVarPath = `/listings/details/{mls}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"mls"}}`, encodeURIComponent(String(mls)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (select !== undefined) {
                localVarQueryParameter['select'] = select;
            }
            if (expand !== undefined) {
                localVarQueryParameter['expand'] = expand;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (locationData !== undefined) {
                localVarQueryParameter['locationData'] = locationData;
            }
            if (isDevelopment !== undefined) {
                localVarQueryParameter['IsDevelopment'] = isDevelopment;
            }
            if (reconvert !== undefined) {
                localVarQueryParameter['reconvert'] = reconvert;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary
         * @param {string} query
         * @param {string} locale
         * @param {boolean} evOnly
         * @param {Array<string>} [countries]
         * @param {Array<string>} [shopIds]
         * @param {Array<PropertyTypeEnum>} [propertyTypes]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingPredictions: (query_1, locale_1, evOnly_1, countries_1, shopIds_1, propertyTypes_1, size_1, ...args_1) => __awaiter(this, [query_1, locale_1, evOnly_1, countries_1, shopIds_1, propertyTypes_1, size_1, ...args_1], void 0, function* (query, locale, evOnly, countries, shopIds, propertyTypes, size, options = {}) {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getListingPredictions', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getListingPredictions', 'locale', locale);
            // verify required parameter 'evOnly' is not null or undefined
            assertParamExists('getListingPredictions', 'evOnly', evOnly);
            const localVarPath = `/listings/predictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (evOnly !== undefined) {
                localVarQueryParameter['evOnly'] = evOnly;
            }
            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }
            if (shopIds) {
                localVarQueryParameter['shopIds'] = shopIds;
            }
            if (propertyTypes) {
                localVarQueryParameter['propertyTypes'] = propertyTypes;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves all listings
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings: (page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1) => __awaiter(this, [page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1], void 0, function* (page, size, sortKey, sortDir, listingFilters, options = {}) {
            const localVarPath = `/listings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listingFilters, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves all listings for a specified advisor
         * @param {string} id
         * @param {boolean} isTeam
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetListingsByAdvisorSortKeyEnum} [sortKey]
         * @param {GetListingsByAdvisorSortDirEnum} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByAdvisor: (id_1, isTeam_1, page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1) => __awaiter(this, [id_1, isTeam_1, page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1], void 0, function* (id, isTeam, page, size, sortKey, sortDir, listingFilters, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListingsByAdvisor', 'id', id);
            // verify required parameter 'isTeam' is not null or undefined
            assertParamExists('getListingsByAdvisor', 'isTeam', isTeam);
            const localVarPath = `/advisors/{id}/listings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isTeam !== undefined) {
                localVarQueryParameter['isTeam'] = isTeam;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listingFilters, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves listings by developmentId
         * @summary
         * @param {string} id
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByDevelopment: (id_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1) => __awaiter(this, [id_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1], void 0, function* (id, page, size, sortKey, sortDir, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListingsByDevelopment', 'id', id);
            const localVarPath = `/developments/{id}/listings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves listings by ListingIds and ListOfficeMlsIds if they exist
         * @summary
         * @param {ListingsByIdBody} listingsByIdBody
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByIds: (listingsByIdBody_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1) => __awaiter(this, [listingsByIdBody_1, page_1, size_1, sortKey_1, sortDir_1, ...args_1], void 0, function* (listingsByIdBody, page, size, sortKey, sortDir, options = {}) {
            // verify required parameter 'listingsByIdBody' is not null or undefined
            assertParamExists('getListingsByIds', 'listingsByIdBody', listingsByIdBody);
            const localVarPath = `/listings/by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listingsByIdBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves all listings in a specified neighborhood
         * @param {string} id
         * @param {string} country
         * @param {string} [locale]
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByNeighborhood: (id_1, country_1, locale_1, page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1) => __awaiter(this, [id_1, country_1, locale_1, page_1, size_1, sortKey_1, sortDir_1, listingFilters_1, ...args_1], void 0, function* (id, country, locale, page, size, sortKey, sortDir, listingFilters, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getListingsByNeighborhood', 'id', id);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getListingsByNeighborhood', 'country', country);
            const localVarPath = `/neighborhoods/{id}/listings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listingFilters, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by its geog_id
         * @param {string} id
         * @param {LocalLogicCountry} country
         * @param {LocalLogicLocale} [locale]
         * @param {boolean} [profiles]
         * @param {boolean} [demographics]
         * @param {boolean} [schools]
         * @param {boolean} [pois]
         * @param {boolean} [geography]
         * @param {number} [radius]
         * @param {LocalLogicRadiusUnit} [radiusUnit]
         * @param {number} [poiLimit]
         * @param {Array<LocalLogicPoiType>} [poiInclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodById: (id_1, country_1, locale_1, profiles_1, demographics_1, schools_1, pois_1, geography_1, radius_1, radiusUnit_1, poiLimit_1, poiInclude_1, ...args_1) => __awaiter(this, [id_1, country_1, locale_1, profiles_1, demographics_1, schools_1, pois_1, geography_1, radius_1, radiusUnit_1, poiLimit_1, poiInclude_1, ...args_1], void 0, function* (id, country, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocalLogicNeighborhoodById', 'id', id);
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getLocalLogicNeighborhoodById', 'country', country);
            const localVarPath = `/neighborhoods/locallogic/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (profiles !== undefined) {
                localVarQueryParameter['profiles'] = profiles;
            }
            if (demographics !== undefined) {
                localVarQueryParameter['demographics'] = demographics;
            }
            if (schools !== undefined) {
                localVarQueryParameter['schools'] = schools;
            }
            if (pois !== undefined) {
                localVarQueryParameter['pois'] = pois;
            }
            if (geography !== undefined) {
                localVarQueryParameter['geography'] = geography;
            }
            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }
            if (radiusUnit !== undefined) {
                localVarQueryParameter['radiusUnit'] = radiusUnit;
            }
            if (poiLimit !== undefined) {
                localVarQueryParameter['poiLimit'] = poiLimit;
            }
            if (poiInclude) {
                localVarQueryParameter['poiInclude'] = poiInclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by latitude and longitude
         * @param {LocalLogicCountry} country
         * @param {number} lat
         * @param {number} lng
         * @param {LocalLogicLocale} [locale]
         * @param {boolean} [profiles]
         * @param {boolean} [demographics]
         * @param {boolean} [schools]
         * @param {boolean} [pois]
         * @param {boolean} [geography]
         * @param {number} [radius]
         * @param {LocalLogicRadiusUnit} [radiusUnit]
         * @param {number} [poiLimit]
         * @param {Array<LocalLogicPoiType>} [poiInclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodByLatLng: (country_1, lat_1, lng_1, locale_1, profiles_1, demographics_1, schools_1, pois_1, geography_1, radius_1, radiusUnit_1, poiLimit_1, poiInclude_1, ...args_1) => __awaiter(this, [country_1, lat_1, lng_1, locale_1, profiles_1, demographics_1, schools_1, pois_1, geography_1, radius_1, radiusUnit_1, poiLimit_1, poiInclude_1, ...args_1], void 0, function* (country, lat, lng, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options = {}) {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getLocalLogicNeighborhoodByLatLng', 'country', country);
            // verify required parameter 'lat' is not null or undefined
            assertParamExists('getLocalLogicNeighborhoodByLatLng', 'lat', lat);
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('getLocalLogicNeighborhoodByLatLng', 'lng', lng);
            const localVarPath = `/neighborhoods/locallogic/latlng`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }
            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (profiles !== undefined) {
                localVarQueryParameter['profiles'] = profiles;
            }
            if (demographics !== undefined) {
                localVarQueryParameter['demographics'] = demographics;
            }
            if (schools !== undefined) {
                localVarQueryParameter['schools'] = schools;
            }
            if (pois !== undefined) {
                localVarQueryParameter['pois'] = pois;
            }
            if (geography !== undefined) {
                localVarQueryParameter['geography'] = geography;
            }
            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }
            if (radiusUnit !== undefined) {
                localVarQueryParameter['radiusUnit'] = radiusUnit;
            }
            if (poiLimit !== undefined) {
                localVarQueryParameter['poiLimit'] = poiLimit;
            }
            if (poiInclude) {
                localVarQueryParameter['poiInclude'] = poiInclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary
         * @param {string} query
         * @param {string} locale
         * @param {boolean} evOnly
         * @param {Array<string>} [countries]
         * @param {Array<string>} [shopIds]
         * @param {number} [lat]
         * @param {number} [lng]
         * @param {Array<PropertyTypeEnum>} [propertyTypes]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPredictions: (query_1, locale_1, evOnly_1, countries_1, shopIds_1, lat_1, lng_1, propertyTypes_1, size_1, ...args_1) => __awaiter(this, [query_1, locale_1, evOnly_1, countries_1, shopIds_1, lat_1, lng_1, propertyTypes_1, size_1, ...args_1], void 0, function* (query, locale, evOnly, countries, shopIds, lat, lng, propertyTypes, size, options = {}) {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('getLocationPredictions', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getLocationPredictions', 'locale', locale);
            // verify required parameter 'evOnly' is not null or undefined
            assertParamExists('getLocationPredictions', 'evOnly', evOnly);
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (evOnly !== undefined) {
                localVarQueryParameter['evOnly'] = evOnly;
            }
            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }
            if (shopIds) {
                localVarQueryParameter['shopIds'] = shopIds;
            }
            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }
            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }
            if (propertyTypes) {
                localVarQueryParameter['propertyTypes'] = propertyTypes;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a neighborhood with matching ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNeighborhoodById', 'id', id);
            const localVarPath = `/neighborhoods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a neighborhood with matching shopIds and slug
         * @param {Array<string>} [shopIds]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodBySlug: (shopIds_1, slug_1, ...args_1) => __awaiter(this, [shopIds_1, slug_1, ...args_1], void 0, function* (shopIds, slug, options = {}) {
            const localVarPath = `/neighborhoods/by-slug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (shopIds) {
                localVarQueryParameter['shopIds'] = shopIds;
            }
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves neighborhoods with matching shopIds
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodsByShop: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getNeighborhoodsByShop', 'id', id);
            const localVarPath = `/shops/{id}/neighborhoods`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all saved searches for a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedSearches: (userId_1, ...args_1) => __awaiter(this, [userId_1, ...args_1], void 0, function* (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSavedSearches', 'userId', userId);
            const localVarPath = `/users/{userId}/saved-searches`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a single shop by shopId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShopById', 'id', id);
            const localVarPath = `/shops/shops/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves a single shop-group by shopGroupId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopGroupById: (id_1, ...args_1) => __awaiter(this, [id_1, ...args_1], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShopGroupById', 'id', id);
            const localVarPath = `/shops/shop-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves shops by place
         * @param {string} [sortDir]
         * @param {string} [sortKey]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [shops]
         * @param {string} [search]
         * @param {string} [select]
         * @param {string} [languages]
         * @param {string} [specializations]
         * @param {string} [positions]
         * @param {string} [group]
         * @param {string} [state]
         * @param {string} [city]
         * @param {string} [teamIds]
         * @param {string} [shopIds]
         * @param {string} [agentIds]
         * @param {string} [expand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopsByPlace: (sortDir_1, sortKey_1, name_1, limit_1, offset_1, shops_1, search_1, select_1, languages_1, specializations_1, positions_1, group_1, state_1, city_1, teamIds_1, shopIds_1, agentIds_1, expand_1, ...args_1) => __awaiter(this, [sortDir_1, sortKey_1, name_1, limit_1, offset_1, shops_1, search_1, select_1, languages_1, specializations_1, positions_1, group_1, state_1, city_1, teamIds_1, shopIds_1, agentIds_1, expand_1, ...args_1], void 0, function* (sortDir, sortKey, name, limit, offset, shops, search, select, languages, specializations, positions, group, state, city, teamIds, shopIds, agentIds, expand, options = {}) {
            const localVarPath = `/shops/shops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }
            if (sortKey !== undefined) {
                localVarQueryParameter['sortKey'] = sortKey;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (shops !== undefined) {
                localVarQueryParameter['shops'] = shops;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (select !== undefined) {
                localVarQueryParameter['select'] = select;
            }
            if (languages !== undefined) {
                localVarQueryParameter['languages'] = languages;
            }
            if (specializations !== undefined) {
                localVarQueryParameter['specializations'] = specializations;
            }
            if (positions !== undefined) {
                localVarQueryParameter['positions'] = positions;
            }
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (teamIds !== undefined) {
                localVarQueryParameter['teamIds'] = teamIds;
            }
            if (shopIds !== undefined) {
                localVarQueryParameter['shopIds'] = shopIds;
            }
            if (agentIds !== undefined) {
                localVarQueryParameter['agentIds'] = agentIds;
            }
            if (expand !== undefined) {
                localVarQueryParameter['expand'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds a listing to user favorites
         * @param {string} userId
         * @param {CreateUserFavoriteDto} createUserFavoriteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFavorite: (userId_1, createUserFavoriteDto_1, ...args_1) => __awaiter(this, [userId_1, createUserFavoriteDto_1, ...args_1], void 0, function* (userId, createUserFavoriteDto, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('saveFavorite', 'userId', userId);
            // verify required parameter 'createUserFavoriteDto' is not null or undefined
            assertParamExists('saveFavorite', 'createUserFavoriteDto', createUserFavoriteDto);
            const localVarPath = `/users/{userId}/favorites`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserFavoriteDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds or increments the count for a frequently searched area
         * @param {SaveFrequentlySearchedAreaDto} saveFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFrequentlySearchedArea: (saveFrequentlySearchedAreaDto_1, ...args_1) => __awaiter(this, [saveFrequentlySearchedAreaDto_1, ...args_1], void 0, function* (saveFrequentlySearchedAreaDto, options = {}) {
            // verify required parameter 'saveFrequentlySearchedAreaDto' is not null or undefined
            assertParamExists('saveFrequentlySearchedArea', 'saveFrequentlySearchedAreaDto', saveFrequentlySearchedAreaDto);
            const localVarPath = `/frequently-searched-areas/log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveFrequentlySearchedAreaDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Adds a search to user saved searches
         * @param {string} userId
         * @param {CreateUserSavedSearchDto} createUserSavedSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSearch: (userId_1, createUserSavedSearchDto_1, ...args_1) => __awaiter(this, [userId_1, createUserSavedSearchDto_1, ...args_1], void 0, function* (userId, createUserSavedSearchDto, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('saveSearch', 'userId', userId);
            // verify required parameter 'createUserSavedSearchDto' is not null or undefined
            assertParamExists('saveSearch', 'createUserSavedSearchDto', createUserSavedSearchDto);
            const localVarPath = `/users/{userId}/saved-searches`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createUserSavedSearchDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verifies the reCAPTCHA response and assesses the user.
         * @param {RecaptchaBody} recaptchaBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRecaptcha: (recaptchaBody_1, ...args_1) => __awaiter(this, [recaptchaBody_1, ...args_1], void 0, function* (recaptchaBody, options = {}) {
            // verify required parameter 'recaptchaBody' is not null or undefined
            assertParamExists('verifyRecaptcha', 'recaptchaBody', recaptchaBody);
            const localVarPath = `/recaptcha/verify-recaptcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recaptchaBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Manually trigger aggregation of searched areas
         * @param {GetFrequentlySearchedAreaDto} getFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggreateSearchedAreas(getFrequentlySearchedAreaDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aggreateSearchedAreas(getFrequentlySearchedAreaDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.aggreateSearchedAreas']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create lofty leads with notes
         * @param {CreateLoftyLeadDto} createLoftyLeadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoftyLeads(createLoftyLeadDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLoftyLeads(createLoftyLeadDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.createLoftyLeads']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Removes a listing from user favorites
         * @param {string} userId
         * @param {string} favoriteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite(userId, favoriteId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFavorite(userId, favoriteId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.deleteFavorite']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Removes a search from user saved searches
         * @param {string} userId
         * @param {string} searchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedSearch(userId, searchId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSavedSearch(userId, searchId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.deleteSavedSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves all advisors
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetAdvisorsSortKeyEnum} [sortKey]
         * @param {GetAdvisorsSortDirEnum} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisors(page, size, sortKey, sortDir, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdvisors(page, size, sortKey, sortDir, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getAdvisors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves advisors for a specific shop(s)
         * @param {string} shopIds
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetAdvisorsByShopSortKeyEnum} [sortKey]
         * @param {GetAdvisorsByShopSortDirEnum} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisorsByShop(shopIds, page, size, sortKey, sortDir, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdvisorsByShop(shopIds, page, size, sortKey, sortDir, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getAdvisorsByShop']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves contentful neighborhoods with matching search term & country
         * @param {string} searchTerm
         * @param {string} locale
         * @param {Array<string>} [countries]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentfulNeighborhoodsBySearchTerm(searchTerm, locale, countries, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getContentfulNeighborhoodsBySearchTerm(searchTerm, locale, countries, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getContentfulNeighborhoodsBySearchTerm']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary return data dictionary of currencies and their rates
         * @param {string} [baseCurrency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyConversions(baseCurrency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrencyConversions(baseCurrency, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getCurrencyConversions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets all favorites for a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavorites(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getFavorites']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets most recent frequently searched areas
         * @param {GetFrequentlySearchedAreaDto} getFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequentlySearchedAreas(getFrequentlySearchedAreaDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFrequentlySearchedAreas(getFrequentlySearchedAreaDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getFrequentlySearchedAreas']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a list by EvaId or ListingId
         * @summary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves detailed information for a listing by EvaId or ListingId
         * @summary
         * @param {string} id
         * @param {string} mls
         * @param {string} [status]
         * @param {string} [select]
         * @param {string} [expand]
         * @param {string} [locale]
         * @param {boolean} [locationData]
         * @param {boolean} [isDevelopment]
         * @param {boolean} [reconvert]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingDetailsById(id, mls, status, select, expand, locale, locationData, isDevelopment, reconvert, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingDetailsById(id, mls, status, select, expand, locale, locationData, isDevelopment, reconvert, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingDetailsById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary
         * @param {string} query
         * @param {string} locale
         * @param {boolean} evOnly
         * @param {Array<string>} [countries]
         * @param {Array<string>} [shopIds]
         * @param {Array<PropertyTypeEnum>} [propertyTypes]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingPredictions(query, locale, evOnly, countries, shopIds, propertyTypes, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingPredictions(query, locale, evOnly, countries, shopIds, propertyTypes, size, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingPredictions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves all listings
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(page, size, sortKey, sortDir, listingFilters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListings(page, size, sortKey, sortDir, listingFilters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves all listings for a specified advisor
         * @param {string} id
         * @param {boolean} isTeam
         * @param {number} [page]
         * @param {number} [size]
         * @param {GetListingsByAdvisorSortKeyEnum} [sortKey]
         * @param {GetListingsByAdvisorSortDirEnum} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByAdvisor(id, isTeam, page, size, sortKey, sortDir, listingFilters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingsByAdvisor(id, isTeam, page, size, sortKey, sortDir, listingFilters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingsByAdvisor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves listings by developmentId
         * @summary
         * @param {string} id
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByDevelopment(id, page, size, sortKey, sortDir, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingsByDevelopment(id, page, size, sortKey, sortDir, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingsByDevelopment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves listings by ListingIds and ListOfficeMlsIds if they exist
         * @summary
         * @param {ListingsByIdBody} listingsByIdBody
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByIds(listingsByIdBody, page, size, sortKey, sortDir, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingsByIds(listingsByIdBody, page, size, sortKey, sortDir, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingsByIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves all listings in a specified neighborhood
         * @param {string} id
         * @param {string} country
         * @param {string} [locale]
         * @param {number} [page]
         * @param {number} [size]
         * @param {ListingSortKeys} [sortKey]
         * @param {SortDir} [sortDir]
         * @param {ListingFilters} [listingFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByNeighborhood(id, country, locale, page, size, sortKey, sortDir, listingFilters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListingsByNeighborhood(id, country, locale, page, size, sortKey, sortDir, listingFilters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getListingsByNeighborhood']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by its geog_id
         * @param {string} id
         * @param {LocalLogicCountry} country
         * @param {LocalLogicLocale} [locale]
         * @param {boolean} [profiles]
         * @param {boolean} [demographics]
         * @param {boolean} [schools]
         * @param {boolean} [pois]
         * @param {boolean} [geography]
         * @param {number} [radius]
         * @param {LocalLogicRadiusUnit} [radiusUnit]
         * @param {number} [poiLimit]
         * @param {Array<LocalLogicPoiType>} [poiInclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodById(id, country, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLocalLogicNeighborhoodById(id, country, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getLocalLogicNeighborhoodById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by latitude and longitude
         * @param {LocalLogicCountry} country
         * @param {number} lat
         * @param {number} lng
         * @param {LocalLogicLocale} [locale]
         * @param {boolean} [profiles]
         * @param {boolean} [demographics]
         * @param {boolean} [schools]
         * @param {boolean} [pois]
         * @param {boolean} [geography]
         * @param {number} [radius]
         * @param {LocalLogicRadiusUnit} [radiusUnit]
         * @param {number} [poiLimit]
         * @param {Array<LocalLogicPoiType>} [poiInclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodByLatLng(country, lat, lng, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLocalLogicNeighborhoodByLatLng(country, lat, lng, locale, profiles, demographics, schools, pois, geography, radius, radiusUnit, poiLimit, poiInclude, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getLocalLogicNeighborhoodByLatLng']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary
         * @param {string} query
         * @param {string} locale
         * @param {boolean} evOnly
         * @param {Array<string>} [countries]
         * @param {Array<string>} [shopIds]
         * @param {number} [lat]
         * @param {number} [lng]
         * @param {Array<PropertyTypeEnum>} [propertyTypes]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPredictions(query, locale, evOnly, countries, shopIds, lat, lng, propertyTypes, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLocationPredictions(query, locale, evOnly, countries, shopIds, lat, lng, propertyTypes, size, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getLocationPredictions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a neighborhood with matching ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNeighborhoodById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getNeighborhoodById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a neighborhood with matching shopIds and slug
         * @param {Array<string>} [shopIds]
         * @param {string} [slug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodBySlug(shopIds, slug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNeighborhoodBySlug(shopIds, slug, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getNeighborhoodBySlug']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves neighborhoods with matching shopIds
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodsByShop(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNeighborhoodsByShop(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getNeighborhoodsByShop']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Gets all saved searches for a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedSearches(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSavedSearches(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getSavedSearches']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a single shop by shopId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShopById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getShopById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves a single shop-group by shopGroupId
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopGroupById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShopGroupById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getShopGroupById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retrieves shops by place
         * @param {string} [sortDir]
         * @param {string} [sortKey]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [shops]
         * @param {string} [search]
         * @param {string} [select]
         * @param {string} [languages]
         * @param {string} [specializations]
         * @param {string} [positions]
         * @param {string} [group]
         * @param {string} [state]
         * @param {string} [city]
         * @param {string} [teamIds]
         * @param {string} [shopIds]
         * @param {string} [agentIds]
         * @param {string} [expand]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopsByPlace(sortDir, sortKey, name, limit, offset, shops, search, select, languages, specializations, positions, group, state, city, teamIds, shopIds, agentIds, expand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShopsByPlace(sortDir, sortKey, name, limit, offset, shops, search, select, languages, specializations, positions, group, state, city, teamIds, shopIds, agentIds, expand, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.getShopsByPlace']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Adds a listing to user favorites
         * @param {string} userId
         * @param {CreateUserFavoriteDto} createUserFavoriteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFavorite(userId, createUserFavoriteDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveFavorite(userId, createUserFavoriteDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.saveFavorite']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Adds or increments the count for a frequently searched area
         * @param {SaveFrequentlySearchedAreaDto} saveFrequentlySearchedAreaDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFrequentlySearchedArea(saveFrequentlySearchedAreaDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveFrequentlySearchedArea(saveFrequentlySearchedAreaDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.saveFrequentlySearchedArea']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Adds a search to user saved searches
         * @param {string} userId
         * @param {CreateUserSavedSearchDto} createUserSavedSearchDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSearch(userId, createUserSavedSearchDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveSearch(userId, createUserSavedSearchDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.saveSearch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.status(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.status']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Verifies the reCAPTCHA response and assesses the user.
         * @param {RecaptchaBody} recaptchaBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRecaptcha(recaptchaBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyRecaptcha(recaptchaBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.verifyRecaptcha']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Manually trigger aggregation of searched areas
         * @param {DefaultApiAggreateSearchedAreasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aggreateSearchedAreas(requestParameters, options) {
            return localVarFp.aggreateSearchedAreas(requestParameters.getFrequentlySearchedAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create lofty leads with notes
         * @param {DefaultApiCreateLoftyLeadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoftyLeads(requestParameters, options) {
            return localVarFp.createLoftyLeads(requestParameters.createLoftyLeadDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a listing from user favorites
         * @param {DefaultApiDeleteFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavorite(requestParameters, options) {
            return localVarFp.deleteFavorite(requestParameters.userId, requestParameters.favoriteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes a search from user saved searches
         * @param {DefaultApiDeleteSavedSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSavedSearch(requestParameters, options) {
            return localVarFp.deleteSavedSearch(requestParameters.userId, requestParameters.searchId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves all advisors
         * @param {DefaultApiGetAdvisorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisors(requestParameters = {}, options) {
            return localVarFp.getAdvisors(requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves advisors for a specific shop(s)
         * @param {DefaultApiGetAdvisorsByShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisorsByShop(requestParameters, options) {
            return localVarFp.getAdvisorsByShop(requestParameters.shopIds, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves contentful neighborhoods with matching search term & country
         * @param {DefaultApiGetContentfulNeighborhoodsBySearchTermRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContentfulNeighborhoodsBySearchTerm(requestParameters, options) {
            return localVarFp.getContentfulNeighborhoodsBySearchTerm(requestParameters.searchTerm, requestParameters.locale, requestParameters.countries, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary return data dictionary of currencies and their rates
         * @param {DefaultApiGetCurrencyConversionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyConversions(requestParameters = {}, options) {
            return localVarFp.getCurrencyConversions(requestParameters.baseCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all favorites for a user
         * @param {DefaultApiGetFavoritesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavorites(requestParameters, options) {
            return localVarFp.getFavorites(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets most recent frequently searched areas
         * @param {DefaultApiGetFrequentlySearchedAreasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrequentlySearchedAreas(requestParameters, options) {
            return localVarFp.getFrequentlySearchedAreas(requestParameters.getFrequentlySearchedAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list by EvaId or ListingId
         * @summary
         * @param {DefaultApiGetListingByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingById(requestParameters, options) {
            return localVarFp.getListingById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves detailed information for a listing by EvaId or ListingId
         * @summary
         * @param {DefaultApiGetListingDetailsByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingDetailsById(requestParameters, options) {
            return localVarFp.getListingDetailsById(requestParameters.id, requestParameters.mls, requestParameters.status, requestParameters.select, requestParameters.expand, requestParameters.locale, requestParameters.locationData, requestParameters.isDevelopment, requestParameters.reconvert, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {DefaultApiGetListingPredictionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingPredictions(requestParameters, options) {
            return localVarFp.getListingPredictions(requestParameters.query, requestParameters.locale, requestParameters.evOnly, requestParameters.countries, requestParameters.shopIds, requestParameters.propertyTypes, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves all listings
         * @param {DefaultApiGetListingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(requestParameters = {}, options) {
            return localVarFp.getListings(requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves all listings for a specified advisor
         * @param {DefaultApiGetListingsByAdvisorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByAdvisor(requestParameters, options) {
            return localVarFp.getListingsByAdvisor(requestParameters.id, requestParameters.isTeam, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves listings by developmentId
         * @summary
         * @param {DefaultApiGetListingsByDevelopmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByDevelopment(requestParameters, options) {
            return localVarFp.getListingsByDevelopment(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves listings by ListingIds and ListOfficeMlsIds if they exist
         * @summary
         * @param {DefaultApiGetListingsByIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByIds(requestParameters, options) {
            return localVarFp.getListingsByIds(requestParameters.listingsByIdBody, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves all listings in a specified neighborhood
         * @param {DefaultApiGetListingsByNeighborhoodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListingsByNeighborhood(requestParameters, options) {
            return localVarFp.getListingsByNeighborhood(requestParameters.id, requestParameters.country, requestParameters.locale, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by its geog_id
         * @param {DefaultApiGetLocalLogicNeighborhoodByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodById(requestParameters, options) {
            return localVarFp.getLocalLogicNeighborhoodById(requestParameters.id, requestParameters.country, requestParameters.locale, requestParameters.profiles, requestParameters.demographics, requestParameters.schools, requestParameters.pois, requestParameters.geography, requestParameters.radius, requestParameters.radiusUnit, requestParameters.poiLimit, requestParameters.poiInclude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a Local Logic neighborhood by latitude and longitude
         * @param {DefaultApiGetLocalLogicNeighborhoodByLatLngRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalLogicNeighborhoodByLatLng(requestParameters, options) {
            return localVarFp.getLocalLogicNeighborhoodByLatLng(requestParameters.country, requestParameters.lat, requestParameters.lng, requestParameters.locale, requestParameters.profiles, requestParameters.demographics, requestParameters.schools, requestParameters.pois, requestParameters.geography, requestParameters.radius, requestParameters.radiusUnit, requestParameters.poiLimit, requestParameters.poiInclude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {DefaultApiGetLocationPredictionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPredictions(requestParameters, options) {
            return localVarFp.getLocationPredictions(requestParameters.query, requestParameters.locale, requestParameters.evOnly, requestParameters.countries, requestParameters.shopIds, requestParameters.lat, requestParameters.lng, requestParameters.propertyTypes, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a neighborhood with matching ID
         * @param {DefaultApiGetNeighborhoodByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodById(requestParameters, options) {
            return localVarFp.getNeighborhoodById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a neighborhood with matching shopIds and slug
         * @param {DefaultApiGetNeighborhoodBySlugRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodBySlug(requestParameters = {}, options) {
            return localVarFp.getNeighborhoodBySlug(requestParameters.shopIds, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves neighborhoods with matching shopIds
         * @param {DefaultApiGetNeighborhoodsByShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNeighborhoodsByShop(requestParameters, options) {
            return localVarFp.getNeighborhoodsByShop(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all saved searches for a user
         * @param {DefaultApiGetSavedSearchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedSearches(requestParameters, options) {
            return localVarFp.getSavedSearches(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a single shop by shopId
         * @param {DefaultApiGetShopByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopById(requestParameters, options) {
            return localVarFp.getShopById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves a single shop-group by shopGroupId
         * @param {DefaultApiGetShopGroupByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopGroupById(requestParameters, options) {
            return localVarFp.getShopGroupById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves shops by place
         * @param {DefaultApiGetShopsByPlaceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShopsByPlace(requestParameters = {}, options) {
            return localVarFp.getShopsByPlace(requestParameters.sortDir, requestParameters.sortKey, requestParameters.name, requestParameters.limit, requestParameters.offset, requestParameters.shops, requestParameters.search, requestParameters.select, requestParameters.languages, requestParameters.specializations, requestParameters.positions, requestParameters.group, requestParameters.state, requestParameters.city, requestParameters.teamIds, requestParameters.shopIds, requestParameters.agentIds, requestParameters.expand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds a listing to user favorites
         * @param {DefaultApiSaveFavoriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFavorite(requestParameters, options) {
            return localVarFp.saveFavorite(requestParameters.userId, requestParameters.createUserFavoriteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds or increments the count for a frequently searched area
         * @param {DefaultApiSaveFrequentlySearchedAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFrequentlySearchedArea(requestParameters, options) {
            return localVarFp.saveFrequentlySearchedArea(requestParameters.saveFrequentlySearchedAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Adds a search to user saved searches
         * @param {DefaultApiSaveSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSearch(requestParameters, options) {
            return localVarFp.saveSearch(requestParameters.userId, requestParameters.createUserSavedSearchDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options) {
            return localVarFp.status(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verifies the reCAPTCHA response and assesses the user.
         * @param {DefaultApiVerifyRecaptchaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRecaptcha(requestParameters, options) {
            return localVarFp.verifyRecaptcha(requestParameters.recaptchaBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary Manually trigger aggregation of searched areas
     * @param {DefaultApiAggreateSearchedAreasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aggreateSearchedAreas(requestParameters, options) {
        return DefaultApiFp(this.configuration).aggreateSearchedAreas(requestParameters.getFrequentlySearchedAreaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create lofty leads with notes
     * @param {DefaultApiCreateLoftyLeadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createLoftyLeads(requestParameters, options) {
        return DefaultApiFp(this.configuration).createLoftyLeads(requestParameters.createLoftyLeadDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a listing from user favorites
     * @param {DefaultApiDeleteFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteFavorite(requestParameters, options) {
        return DefaultApiFp(this.configuration).deleteFavorite(requestParameters.userId, requestParameters.favoriteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes a search from user saved searches
     * @param {DefaultApiDeleteSavedSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteSavedSearch(requestParameters, options) {
        return DefaultApiFp(this.configuration).deleteSavedSearch(requestParameters.userId, requestParameters.searchId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves all advisors
     * @param {DefaultApiGetAdvisorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAdvisors(requestParameters = {}, options) {
        return DefaultApiFp(this.configuration).getAdvisors(requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves advisors for a specific shop(s)
     * @param {DefaultApiGetAdvisorsByShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAdvisorsByShop(requestParameters, options) {
        return DefaultApiFp(this.configuration).getAdvisorsByShop(requestParameters.shopIds, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves contentful neighborhoods with matching search term & country
     * @param {DefaultApiGetContentfulNeighborhoodsBySearchTermRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getContentfulNeighborhoodsBySearchTerm(requestParameters, options) {
        return DefaultApiFp(this.configuration).getContentfulNeighborhoodsBySearchTerm(requestParameters.searchTerm, requestParameters.locale, requestParameters.countries, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary return data dictionary of currencies and their rates
     * @param {DefaultApiGetCurrencyConversionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrencyConversions(requestParameters = {}, options) {
        return DefaultApiFp(this.configuration).getCurrencyConversions(requestParameters.baseCurrency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all favorites for a user
     * @param {DefaultApiGetFavoritesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getFavorites(requestParameters, options) {
        return DefaultApiFp(this.configuration).getFavorites(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets most recent frequently searched areas
     * @param {DefaultApiGetFrequentlySearchedAreasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getFrequentlySearchedAreas(requestParameters, options) {
        return DefaultApiFp(this.configuration).getFrequentlySearchedAreas(requestParameters.getFrequentlySearchedAreaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a list by EvaId or ListingId
     * @summary
     * @param {DefaultApiGetListingByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves detailed information for a listing by EvaId or ListingId
     * @summary
     * @param {DefaultApiGetListingDetailsByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingDetailsById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingDetailsById(requestParameters.id, requestParameters.mls, requestParameters.status, requestParameters.select, requestParameters.expand, requestParameters.locale, requestParameters.locationData, requestParameters.isDevelopment, requestParameters.reconvert, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary
     * @param {DefaultApiGetListingPredictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingPredictions(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingPredictions(requestParameters.query, requestParameters.locale, requestParameters.evOnly, requestParameters.countries, requestParameters.shopIds, requestParameters.propertyTypes, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves all listings
     * @param {DefaultApiGetListingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListings(requestParameters = {}, options) {
        return DefaultApiFp(this.configuration).getListings(requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves all listings for a specified advisor
     * @param {DefaultApiGetListingsByAdvisorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingsByAdvisor(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingsByAdvisor(requestParameters.id, requestParameters.isTeam, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves listings by developmentId
     * @summary
     * @param {DefaultApiGetListingsByDevelopmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingsByDevelopment(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingsByDevelopment(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves listings by ListingIds and ListOfficeMlsIds if they exist
     * @summary
     * @param {DefaultApiGetListingsByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingsByIds(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingsByIds(requestParameters.listingsByIdBody, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves all listings in a specified neighborhood
     * @param {DefaultApiGetListingsByNeighborhoodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getListingsByNeighborhood(requestParameters, options) {
        return DefaultApiFp(this.configuration).getListingsByNeighborhood(requestParameters.id, requestParameters.country, requestParameters.locale, requestParameters.page, requestParameters.size, requestParameters.sortKey, requestParameters.sortDir, requestParameters.listingFilters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a Local Logic neighborhood by its geog_id
     * @param {DefaultApiGetLocalLogicNeighborhoodByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLocalLogicNeighborhoodById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getLocalLogicNeighborhoodById(requestParameters.id, requestParameters.country, requestParameters.locale, requestParameters.profiles, requestParameters.demographics, requestParameters.schools, requestParameters.pois, requestParameters.geography, requestParameters.radius, requestParameters.radiusUnit, requestParameters.poiLimit, requestParameters.poiInclude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a Local Logic neighborhood by latitude and longitude
     * @param {DefaultApiGetLocalLogicNeighborhoodByLatLngRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLocalLogicNeighborhoodByLatLng(requestParameters, options) {
        return DefaultApiFp(this.configuration).getLocalLogicNeighborhoodByLatLng(requestParameters.country, requestParameters.lat, requestParameters.lng, requestParameters.locale, requestParameters.profiles, requestParameters.demographics, requestParameters.schools, requestParameters.pois, requestParameters.geography, requestParameters.radius, requestParameters.radiusUnit, requestParameters.poiLimit, requestParameters.poiInclude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary
     * @param {DefaultApiGetLocationPredictionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getLocationPredictions(requestParameters, options) {
        return DefaultApiFp(this.configuration).getLocationPredictions(requestParameters.query, requestParameters.locale, requestParameters.evOnly, requestParameters.countries, requestParameters.shopIds, requestParameters.lat, requestParameters.lng, requestParameters.propertyTypes, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a neighborhood with matching ID
     * @param {DefaultApiGetNeighborhoodByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getNeighborhoodById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getNeighborhoodById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a neighborhood with matching shopIds and slug
     * @param {DefaultApiGetNeighborhoodBySlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getNeighborhoodBySlug(requestParameters = {}, options) {
        return DefaultApiFp(this.configuration).getNeighborhoodBySlug(requestParameters.shopIds, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves neighborhoods with matching shopIds
     * @param {DefaultApiGetNeighborhoodsByShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getNeighborhoodsByShop(requestParameters, options) {
        return DefaultApiFp(this.configuration).getNeighborhoodsByShop(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all saved searches for a user
     * @param {DefaultApiGetSavedSearchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSavedSearches(requestParameters, options) {
        return DefaultApiFp(this.configuration).getSavedSearches(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a single shop by shopId
     * @param {DefaultApiGetShopByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShopById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getShopById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves a single shop-group by shopGroupId
     * @param {DefaultApiGetShopGroupByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShopGroupById(requestParameters, options) {
        return DefaultApiFp(this.configuration).getShopGroupById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves shops by place
     * @param {DefaultApiGetShopsByPlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getShopsByPlace(requestParameters = {}, options) {
        return DefaultApiFp(this.configuration).getShopsByPlace(requestParameters.sortDir, requestParameters.sortKey, requestParameters.name, requestParameters.limit, requestParameters.offset, requestParameters.shops, requestParameters.search, requestParameters.select, requestParameters.languages, requestParameters.specializations, requestParameters.positions, requestParameters.group, requestParameters.state, requestParameters.city, requestParameters.teamIds, requestParameters.shopIds, requestParameters.agentIds, requestParameters.expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds a listing to user favorites
     * @param {DefaultApiSaveFavoriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    saveFavorite(requestParameters, options) {
        return DefaultApiFp(this.configuration).saveFavorite(requestParameters.userId, requestParameters.createUserFavoriteDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds or increments the count for a frequently searched area
     * @param {DefaultApiSaveFrequentlySearchedAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    saveFrequentlySearchedArea(requestParameters, options) {
        return DefaultApiFp(this.configuration).saveFrequentlySearchedArea(requestParameters.saveFrequentlySearchedAreaDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Adds a search to user saved searches
     * @param {DefaultApiSaveSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    saveSearch(requestParameters, options) {
        return DefaultApiFp(this.configuration).saveSearch(requestParameters.userId, requestParameters.createUserSavedSearchDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    status(options) {
        return DefaultApiFp(this.configuration).status(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verifies the reCAPTCHA response and assesses the user.
     * @param {DefaultApiVerifyRecaptchaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    verifyRecaptcha(requestParameters, options) {
        return DefaultApiFp(this.configuration).verifyRecaptcha(requestParameters.recaptchaBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
  * @export
  * @enum {string}
  */
export var GetAdvisorsSortKeyEnum;
(function (GetAdvisorsSortKeyEnum) {
    GetAdvisorsSortKeyEnum["FirstName"] = "firstName";
    GetAdvisorsSortKeyEnum["LastName"] = "lastName";
})(GetAdvisorsSortKeyEnum || (GetAdvisorsSortKeyEnum = {}));
/**
  * @export
  * @enum {string}
  */
export var GetAdvisorsSortDirEnum;
(function (GetAdvisorsSortDirEnum) {
    GetAdvisorsSortDirEnum["Asc"] = "asc";
    GetAdvisorsSortDirEnum["Desc"] = "desc";
})(GetAdvisorsSortDirEnum || (GetAdvisorsSortDirEnum = {}));
/**
  * @export
  * @enum {string}
  */
export var GetAdvisorsByShopSortKeyEnum;
(function (GetAdvisorsByShopSortKeyEnum) {
    GetAdvisorsByShopSortKeyEnum["FirstName"] = "firstName";
    GetAdvisorsByShopSortKeyEnum["LastName"] = "lastName";
})(GetAdvisorsByShopSortKeyEnum || (GetAdvisorsByShopSortKeyEnum = {}));
/**
  * @export
  * @enum {string}
  */
export var GetAdvisorsByShopSortDirEnum;
(function (GetAdvisorsByShopSortDirEnum) {
    GetAdvisorsByShopSortDirEnum["Asc"] = "asc";
    GetAdvisorsByShopSortDirEnum["Desc"] = "desc";
})(GetAdvisorsByShopSortDirEnum || (GetAdvisorsByShopSortDirEnum = {}));
/**
  * @export
  * @enum {string}
  */
export var GetListingsByAdvisorSortKeyEnum;
(function (GetListingsByAdvisorSortKeyEnum) {
    GetListingsByAdvisorSortKeyEnum["UsdListPrice"] = "UsdListPrice";
    GetListingsByAdvisorSortKeyEnum["EvaId"] = "EvaId";
    GetListingsByAdvisorSortKeyEnum["OnMarketDate"] = "OnMarketDate";
    GetListingsByAdvisorSortKeyEnum["ListAgentMlsId"] = "ListAgentMlsId";
})(GetListingsByAdvisorSortKeyEnum || (GetListingsByAdvisorSortKeyEnum = {}));
/**
  * @export
  * @enum {string}
  */
export var GetListingsByAdvisorSortDirEnum;
(function (GetListingsByAdvisorSortDirEnum) {
    GetListingsByAdvisorSortDirEnum["Asc"] = "asc";
    GetListingsByAdvisorSortDirEnum["Desc"] = "desc";
})(GetListingsByAdvisorSortDirEnum || (GetListingsByAdvisorSortDirEnum = {}));
